import React, { Fragment } from "react"
import { QRCodeSVG } from "qrcode.react"
import { useTranslation } from "react-i18next"

import { moment, scale } from "utils"
import PlSeparator from "./PlSeparator"
import { languageDateFormatMap } from "constant"

const PlQrPrintTemplate = (props) => {
  const {
    forPos,
    templateType,
    printData,
    printerWidth
  } = props

  const {
    tableName,
    subdomain,
    domain,
    qrCodeExpiryTime
  } = printData

  const [t, i18n] = useTranslation()

  const dir = i18n.dir(i18n.language)

  const styles =
    templateType === "thermal"
      ? stylesThermal(printerWidth, dir)
      : stylesOthers(dir)

  const dateFormat =
    languageDateFormatMap[i18n.language]

  const size =
    templateType === "thermal"
      ? 300 / window.devicePixelRatio
      : 100

  const getQrUrl = () => {
    const m = moment().add(qrCodeExpiryTime, "minutes")

    const qrCodeTag =
      Number(Math.random() * 10000000 | 0).toString(36)

    const minutes = m.format("mm")
    const hours = m.format("HH")
    const day = m.format("DD")
    const month = m.format("MM")
    const year = m.format("YYYY")

    const base36 =
      Number(`${year}${hours}${month}${day}${minutes}`).toString(36)

    return `https://${subdomain}.${domain}/?iqr=${base36}*${encodeURIComponent(tableName)}*${qrCodeTag}`
  }

  const qrUrl = getQrUrl()

  return (
    <Fragment>
      <div style={styles["container"]}>
        <div style={styles["text"]}>
          {t("شماره میز")}: {tableName} | {moment().format(`${dateFormat} - HH:mm`)}
        </div>
        <div style={styles["center"]}>
          <QRCodeSVG
            size={size}
            value={qrUrl}
          />
        </div>
        <div style={styles["text"]}>
          1. {t("لطفا کد QR را اسکن کنید")}
        </div>
        <div style={styles["text"]}>
          2. {t("سپس محصول خود را انتخاب کنید")}
        </div>
        <div style={styles["text"]}>
          3. {t("سفارش خود را ثبت کنید")}
        </div>
      </div>

      <PlSeparator
        forPos={forPos}
        templateType={templateType}
      />
    </Fragment>
  )
}

const stylesThermal = (printerWidth) => ({
  container: {
    fontSize: scale("19px", printerWidth),
  },

  text: {
    textAlign: "center",
    marginBottom: scale("8px")
  },
  center: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: `${scale("12px")} 0px`
  }
})

const stylesOthers = () => ({
  container: {
    marginRight: "4px",
    fontSize: "11px"
  },
  text: {
    textAlign: "center",
    marginBottom: "8px"
  },
  center: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: "10px 0px"
  }
})

export default PlQrPrintTemplate